// extracted by mini-css-extract-plugin
export var numberInputContainer = "_88-0";
export var startPickingButton = "_88-1";